module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "atlas-news",
    on: {
      "click": _vm.hideInput
    }
  }, [_c('img', {
    staticStyle: {
      "z-index": "-10",
      "position": "absolute"
    },
    attrs: {
      "src": "https://img.qiluyidian.net/shareimg20191216.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    ref: "tips",
    staticClass: "tips clearfix"
  }, [_c('span', {
    staticClass: "homeIcon",
    style: ({
      backgroundImage: _vm.home_url,
      backgroundSize: '100%'
    }),
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goHome.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "rightLine"
  }), _vm._v(" "), _c('span', {
    staticClass: "slogon"
  }, [_vm._v("齐鲁晚报官方APP")]), _vm._v(" "), _c('span', {
    staticClass: "openApp",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.down.apply(null, arguments)
      }
    }
  }, [_vm._v("打开")])]), _vm._v(" "), (_vm.loading == 0) ? _c('div', {
    staticClass: "loading",
    style: ({
      backgroundImage: _vm.loading_url,
      backgroundSize: '20%'
    })
  }) : (_vm.loading == 1) ? _c('div', {
    staticClass: "loading",
    style: ({
      backgroundImage: _vm.error2_url,
      backgroundSize: '50%'
    })
  }) : (_vm.loading == 2) ? _c('div', {
    staticClass: "loading",
    style: ({
      backgroundImage: _vm.deleted_url,
      backgroundSize: '50%'
    })
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "infoWrapper"
  }, [_c('p', {
    staticClass: "newsTitle"
  }, [_vm._v(_vm._s(_vm.infoDetails.title))]), _vm._v(" "), _c('div', {
    staticClass: "newsAuthor clearfix"
  }, [_c('div', {
    staticClass: "sourceTime"
  }, [(_vm.infoDetails.source) ? _c('span', {
    staticClass: "source"
  }, [_vm._v(_vm._s(_vm.infoDetails.source))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.infoDetails.publishtime))])])]), _vm._v(" "), _c('div', {
    staticClass: "news",
    attrs: {
      "id": "img_box"
    }
  }, _vm._l((_vm.infoDetails.imglist), function(item, index) {
    return _c('p', {
      ref: "content",
      refInFor: true,
      staticClass: "content"
    }, [(item.url) ? _c('img', {
      attrs: {
        "src": item.url + _vm.param,
        "alt": ""
      }
    }) : _c('img', {
      attrs: {
        "src": require("../../common/img/defaultPicture.png"),
        "alt": ""
      }
    }), _vm._v(_vm._s(item.content) + "\n        ")])
  }), 0), _vm._v(" "), (_vm.infoDetails.relate_reporter) ? _c('div', {
    staticClass: "repoterList"
  }, _vm._l((_vm.infoDetails.relate_reporter), function(item, index) {
    return _c('div', {
      staticClass: "repoter clearfix"
    }, [_c('div', {
      staticClass: "imgV",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.sendShow('1', _vm.infoDetails.newsId, item.reporter_id)
        }
      }
    }, [(item.head_img) ? _c('img', {
      staticClass: "headImg",
      attrs: {
        "src": item.head_img,
        "alt": ""
      }
    }) : _c('img', {
      staticClass: "headImg",
      attrs: {
        "src": require("../../common/img/headImg.png"),
        "alt": ""
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "headV",
      attrs: {
        "src": _vm.redV,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "nameAdress"
    }, [_c('p', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.reporter_name))]), _vm._v(" "), _c('p', {
      staticClass: "adress"
    }, [_vm._v(_vm._s(item.signature))])]), _vm._v(" "), _c('span', {
      staticClass: "quest",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.getRetName(item.reporter_name);
          _vm.sendShow('1', _vm.infoDetails.newsId, item.reporter_id)
        }
      }
    }, [_vm._v("爆料")])])
  }), 0) : _vm._e()]), _vm._v(" "), (_vm.infoDetails.sourceInfoList) ? _c('div', {
    staticClass: "hotNews"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.infoDetails.sourceInfoList), function(item, index) {
    return _c('div', {
      staticClass: "newType"
    }, [(item.isAd == '1') ? _c('div', {
      staticClass: "newListAdv",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.goMost(item.isAd, item.conentid, item.detailurl, item.status)
        }
      }
    }, [_c('p', {
      staticClass: "advTitle"
    }, [_vm._v(_vm._s(item.conenttitle))]), _vm._v(" "), (item.conentimg1) ? _c('img', {
      staticClass: "advImg",
      attrs: {
        "src": item.conentimg1 + _vm.param,
        "alt": ""
      }
    }) : _c('img', {
      staticClass: "advImg",
      attrs: {
        "src": require("../../common/img/defaultPicture.png"),
        "alt": ""
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "advText adColor1 clearfix"
    }, [_vm._v("广告")])]) : (item.conenttype == '1' || item.conenttype == '20') ? _c('div', {
      staticClass: "newList clearfix",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.goGeneral(item.conentid)
        }
      }
    }, [(item.conentimg1) ? _c('img', {
      staticClass: "newImg",
      attrs: {
        "src": item.conentimg1 + _vm.param,
        "alt": ""
      }
    }) : _c('img', {
      staticClass: "newImg",
      attrs: {
        "src": require("../../common/img/defaultPicture.png"),
        "alt": ""
      }
    }), _vm._v(" "), (item.conenttype == '20') ? _c('img', {
      staticClass: "ypTips",
      attrs: {
        "src": require("../../common/img/ypTips.png"),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "newsRight"
    }, [_c('p', {
      staticClass: "newsTitle"
    }, [_vm._v(_vm._s(item.conenttitle))]), _vm._v(" "), _c('p', {
      staticClass: "timeView"
    }, [(item.channel_name) ? _c('span', {
      staticClass: "source read"
    }, [_vm._v(_vm._s(item.channel_name))]) : (item.columnName) ? _c('span', {
      staticClass: "source read"
    }, [_vm._v(_vm._s(item.columnName))]) : _c('span', {
      staticClass: "source"
    }, [_vm._v(_vm._s(item.source))]), _vm._v(" "), (item.viewcount != 0 && item.viewcount != '' && item.viewcount >= 1000 || item.viewcount.indexOf('万') != '-1') ? _c('span', {
      staticClass: "yue"
    }, [_vm._v(_vm._s(item.viewcount) + "阅")]) : _vm._e(), _vm._v(" "), (item.commentcount != 0 && item.commentcount != '' && item.viewcount < 1000 && item.viewcount.indexOf('万') == '-1') ? _c('span', {
      staticClass: "ping"
    }, [_vm._v(_vm._s(item.commentcount) + "评")]) : (item.timestr && (item.commentcount == 0 || item.commentcount == '') && item.viewcount < 1000 && item.viewcount.indexOf('万') == '-1') ? _c('span', {
      staticClass: "yue"
    }, [_vm._v(_vm._s(item.timestr))]) : _vm._e()])])]) : (item.conenttype == '10') ? _c('div', {
      staticClass: "newListAdv",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.goLive(item.conentid)
        }
      }
    }, [_c('p', {
      staticClass: "advTitle"
    }, [_vm._v(_vm._s(item.conenttitle))]), _vm._v(" "), (item.conentimg1) ? _c('img', {
      staticClass: "advImg",
      attrs: {
        "src": item.conentimg1 + _vm.param,
        "alt": ""
      }
    }) : _c('img', {
      staticClass: "advImg",
      attrs: {
        "src": require("../../common/img/defaultPicture.png"),
        "alt": ""
      }
    }), _vm._v(" "), (item.conenttype == '6') ? _c('p', {
      staticClass: "advText adColor1"
    }, [_vm._v("活动")]) : (item.conenttype == '5') ? _c('p', {
      staticClass: "advText adColor1"
    }, [_vm._v("商品")]) : (item.conenttype == '8') ? _c('p', {
      staticClass: "advText adColor1"
    }, [_vm._v("图文直播")]) : (item.conenttype == '10' && item.status == '1') ? _c('p', {
      staticClass: "advText adColor1"
    }, [_vm._v("直播")]) : (item.conenttype == '10' && item.status == '2') ? _c('p', {
      staticClass: "advText adColor2"
    }, [_vm._v("预告")]) : _c('p', {
      staticClass: "advText adColor0"
    }, [_vm._v("回顾")])]) : (item.conenttype == '10' || item.conenttype == '6' || item.conenttype == '5' || item.conenttype == '8') ? _c('div', {
      staticClass: "newListAdv",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.goMost(item.type, item.sourceId, item.detailurl, item.status)
        }
      }
    }, [_c('p', {
      staticClass: "advTitle"
    }, [_vm._v(_vm._s(item.conenttitle))]), _vm._v(" "), (item.conentimg1) ? _c('img', {
      staticClass: "advImg",
      attrs: {
        "src": item.conentimg1 + _vm.param,
        "alt": ""
      }
    }) : _c('img', {
      staticClass: "advImg",
      attrs: {
        "src": require("../../common/img/defaultPicture.png"),
        "alt": ""
      }
    }), _vm._v(" "), (item.conenttype == '6') ? _c('p', {
      staticClass: "advText adColor1"
    }, [_vm._v("活动")]) : (item.conenttype == '5') ? _c('p', {
      staticClass: "advText adColor1"
    }, [_vm._v("商品")]) : (item.conenttype == '8') ? _c('p', {
      staticClass: "advText adColor1"
    }, [_vm._v("图文直播")]) : (item.conenttype == '10' && item.status == '1') ? _c('p', {
      staticClass: "advText adColor1"
    }, [_vm._v("直播")]) : (item.conenttype == '10' && item.status == '2') ? _c('p', {
      staticClass: "advText adColor2"
    }, [_vm._v("预告")]) : _c('p', {
      staticClass: "advText adColor0"
    }, [_vm._v("回顾")])]) : (item.conenttype == '3') ? _c('div', {
      staticClass: "newListVideo",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.goVideo(item.conentid)
        }
      }
    }, [_c('p', {
      staticClass: "videoTitle"
    }, [_vm._v(_vm._s(item.conenttitle))]), _vm._v(" "), _c('div', {
      staticClass: "videoWraper"
    }, [(item.conentimg1) ? _c('img', {
      staticClass: "videoImg",
      attrs: {
        "src": item.conentimg1 + _vm.param,
        "alt": ""
      }
    }) : _c('img', {
      staticClass: "videoImg",
      attrs: {
        "src": require("../../common/img/defaultPicture.png"),
        "alt": ""
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "stop",
      style: ({
        backgroundImage: _vm.stop_url,
        backgroundSize: '13%'
      })
    })]), _vm._v(" "), _c('p', {
      staticClass: "videoDetail"
    }, [(item.columnName) ? _c('span', {
      staticClass: "videoText"
    }, [_vm._v(_vm._s(item.columnName))]) : _c('span', {
      staticClass: "videoText"
    }, [_vm._v(_vm._s(item.source))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.timestr))])])]) : (item.conenttype == '2') ? _c('div', {
      staticClass: "newListPic",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.goAtlas(item.conentid)
        }
      }
    }, [_c('p', {
      staticClass: "picTitle"
    }, [_vm._v(_vm._s(item.conenttitle))]), _vm._v(" "), _c('div', {
      staticClass: "picWraper"
    }, [(item.conentimg1) ? _c('img', {
      staticClass: "picImg",
      attrs: {
        "src": item.conentimg1 + _vm.param,
        "alt": ""
      }
    }) : _c('img', {
      staticClass: "picImg",
      attrs: {
        "src": require("../../common/img/defaultPicture.png"),
        "alt": ""
      }
    }), _vm._v(" "), (item.conentimg2) ? _c('img', {
      staticClass: "picImg",
      attrs: {
        "src": item.conentimg2 + _vm.param,
        "alt": ""
      }
    }) : _c('img', {
      staticClass: "picImg",
      attrs: {
        "src": require("../../common/img/defaultPicture.png"),
        "alt": ""
      }
    }), _vm._v(" "), (item.conentimg3) ? _c('img', {
      staticClass: "picImg",
      attrs: {
        "src": item.conentimg3 + _vm.param,
        "alt": ""
      }
    }) : _c('img', {
      staticClass: "picImg",
      attrs: {
        "src": require("../../common/img/defaultPicture.png"),
        "alt": ""
      }
    })])]) : (item.conenttype == '4' && item.subjectNewsList.length > 0) ? _c('div', {
      staticClass: "thematicPic",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.goThematic(item.conentid)
        }
      }
    }, [(item.subjectNewsList.length > 0) ? _c('div', {
      staticClass: "thematic-news",
      attrs: {
        "id": "thematic-news"
      }
    }, [_c('div', {
      staticClass: "inner"
    }, [_c('div', {
      staticClass: "title clearfix"
    }, [_c('span', {
      staticClass: "thematic"
    }, [_vm._v("专题")]), _c('span', {
      staticClass: "thematicTitle"
    }, [_vm._v(_vm._s(item.conenttitle))]), _c('span', {
      staticClass: "more clearfix"
    }, [_vm._v("更多"), _c('i', {
      staticClass: "moreIcon",
      style: ({
        backgroundImage: _vm.more,
        backgroundSize: 'contain'
      })
    })])]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('swiper', {
      attrs: {
        "options": _vm.swiperOptionThematic
      }
    }, _vm._l((item.subjectNewsList), function(sub, index) {
      return _c('swiper-slide', {
        key: index,
        staticClass: "slideItem"
      }, [_c('div', {
        staticClass: "wrap",
        on: {
          "click": function($event) {
            return _vm.goThematic(item.conentid)
          }
        }
      }, [_c('div', {
        staticClass: "videoTop"
      }, [(sub.conentimg1) ? _c('img', {
        attrs: {
          "src": sub.conentimg1 + _vm.param,
          "alt": ""
        }
      }) : _c('img', {
        attrs: {
          "src": require("../../common/img/defaultPicture.png"),
          "alt": ""
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "bottom"
      }, [_c('div', {
        staticClass: "radar-title",
        domProps: {
          "innerHTML": _vm._s(sub.conenttitle)
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "info"
      }, [_c('span', {
        staticClass: "name"
      }, [_vm._v(_vm._s(sub.timestr))])])])])])
    }), 1)], 1)])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (index < _vm.infoDetails.sourceInfoList.length) ? _c('i', {
      staticClass: "line"
    }) : _vm._e()])
  }), _vm._v(" "), (_vm.infoDetails.adinfo) ? _c('div', {
    staticClass: "advPic",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goAdv(_vm.infoDetails.adinfo.detailurl)
      }
    }
  }, [(_vm.infoDetails.adinfo.conentimg1) ? _c('img', {
    attrs: {
      "src": _vm.infoDetails.adinfo.conentimg1,
      "alt": ""
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../common/img/defaultPicture.png"),
      "alt": ""
    }
  })]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "comment",
    staticClass: "commentWraper",
    attrs: {
      "id": "comment"
    }
  }, [(_vm.infoDetails.commentcount > 0) ? _c('p', {
    staticClass: "commentTitle"
  }, [_vm._v("精彩评论(" + _vm._s(_vm.infoDetails.commentcount) + ")")]) : _c('p', {
    staticClass: "commentTitle"
  }, [_vm._v("精彩评论")]), _vm._v(" "), _vm._l((_vm.commentList), function(item, index) {
    return _c('div', {
      staticClass: "commentList"
    }, [_c('div', {
      staticClass: "commentInfo clearfix"
    }, [_c('div', {
      staticClass: "headImg"
    }, [(item.head_img) ? _c('img', {
      attrs: {
        "src": item.head_img,
        "alt": ""
      }
    }) : _c('img', {
      attrs: {
        "src": require("../../common/img/headImg.png"),
        "alt": ""
      }
    }), _vm._v(" "), (item.user_name_status == 2) ? _c('span', {
      staticClass: "v",
      style: ({
        backgroundImage: _vm.v_url,
        backgroundSize: 'contain'
      })
    }) : _vm._e(), _vm._v(" "), (item.user_name_status == 1) ? _c('span', {
      staticClass: "v",
      style: ({
        backgroundImage: _vm.v1_url,
        backgroundSize: 'contain'
      })
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "person"
    }, [_c('p', {
      staticClass: "name v_name commonName"
    }, [_vm._v("\n              " + _vm._s(item.user_name))])]), _vm._v(" "), _c('div', {
      staticClass: "good clearfix"
    }, [(item.is_praise == 0 && item.praise_sum > 0) ? _c('span', {
      staticClass: "goodNo"
    }, [_vm._v(_vm._s(item.praise_sum))]) : (item.praise_sum > 0) ? _c('span', {
      staticClass: "goodNo",
      staticStyle: {
        "color": "#E51C23"
      }
    }, [_vm._v(_vm._s(item.praise_sum))]) : _vm._e(), _vm._v(" "), (item.is_praise == 0) ? _c('span', {
      staticClass: "goodIcon",
      style: ({
        backgroundImage: _vm.good_url,
        backgroundSize: 'contain'
      }),
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.snap(item.inner_id, index)
        }
      }
    }) : _c('span', {
      staticClass: "goodIcon",
      style: ({
        backgroundImage: _vm.good_has_url,
        backgroundSize: 'contain'
      }),
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.hasSnap.apply(null, arguments)
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "commentText",
      domProps: {
        "innerHTML": _vm._s(_vm.processComment(item.content))
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.sendShow('', _vm.infoDetails.newsId, '', item.inner_id)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "commentTimeReply"
    }, [_c('span', {
      staticClass: "commentTime"
    }, [_vm._v(_vm._s(item.sub_time))]), _vm._v(" "), _c('span', {
      staticClass: "commentReply",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.getReplyName(item.user_name);
          _vm.sendShow('', _vm.infoDetails.newsId, '', item.inner_id)
        }
      }
    }, [_vm._v("回复")]), _vm._v(" "), (item.is_opt == 1) ? _c('span', {
      staticClass: "delPreply",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.delRply(item.inner_id)
        }
      }
    }, [_vm._v("删除")]) : _vm._e()]), _vm._v(" "), (item.children.length > 0) ? _c('div', {
      staticClass: "commentOthers"
    }, _vm._l((item.children), function(com) {
      return _c('p', {
        staticClass: "others"
      }, [_c('span', {
        staticClass: "otherName"
      }, [_vm._v(_vm._s(com.user_name) + "：")]), _c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.processComment(com.content))
        }
      })])
    }), 0) : _vm._e(), _vm._v(" "), (index < _vm.commentList.length - 1) ? _c('i', {
      staticClass: "line"
    }) : _vm._e()])
  }), _vm._v(" "), (!_vm.commentList) ? _c('div', {
    staticClass: "noComment"
  }, [_c('img', {
    attrs: {
      "src": require("../../common/img/noComment.png"),
      "alt": ""
    }
  })]) : _vm._e()], 2), _vm._v(" "), (_vm.commentMore) ? _c('div', {
    staticClass: "appGoWrapper",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.down.apply(null, arguments)
      }
    }
  }, [_c('p', {
    staticClass: "openAppGo"
  }, [_vm._v("打开壹点APP，查看更多评论")])]) : _c('div', {
    staticClass: "appGoWrapper1"
  }), _vm._v(" "), (_vm.inputStatus) ? _c('div', {
    staticClass: "commentInput clearfix"
  }, [_c('span', {
    staticClass: "index1",
    style: ({
      backgroundImage: _vm.index1_url,
      backgroundSize: 'contain'
    }),
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goHome.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "inputFalse",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.sendShow('0', _vm.infoDetails.newsId, '', '')
      }
    }
  }, [_vm._v("写评论…")]), _vm._v(" "), _c('span', {
    staticClass: "commentNo",
    style: ({
      backgroundImage: _vm.comment_url,
      backgroundSize: 'contain'
    }),
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goComment(_vm.infoDetails.newsId)
      }
    }
  }, [(_vm.infoDetails.commentcount > 999) ? _c('span', [_vm._v("999+")]) : (_vm.infoDetails.commentcount > 0) ? _c('span', [_vm._v(_vm._s(_vm.infoDetails.commentcount))]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "hotSearch",
    style: ({
      backgroundImage: _vm.hotSearch_url,
      backgroundSize: '100%'
    }),
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goHotSearch.apply(null, arguments)
      }
    }
  }, [(_vm.hotNo > 0 && _vm.hotNo < 101) ? _c('span', [_vm._v(_vm._s(_vm.hotNo))]) : _vm._e()])]) : _c('div', {
    staticClass: "commentInput0 clearfix"
  }, [_c('form', {
    attrs: {
      "action": "javascript:return true"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.formSubmit.apply(null, arguments)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comment),
      expression: "comment"
    }, {
      name: "focus",
      rawName: "v-focus",
      value: (true),
      expression: "true"
    }],
    ref: "inputComtent",
    attrs: {
      "type": "text",
      "placeholder": _vm.dateinit
    },
    domProps: {
      "value": (_vm.comment)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.emojiShow = false
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.reply()
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.comment = $event.target.value
      }, _vm.addColor]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "sendEmoji clearfix"
  }, [_c('span', {
    staticClass: "smile",
    style: ({
      backgroundImage: _vm.smile_url,
      backgroundSize: 'contain'
    }),
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.emoji.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('span', {
    ref: "send",
    staticClass: "send",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.reply();
        _vm.inputStatus = true
      }
    }
  }, [_vm._v("发送")])]), _vm._v(" "), (_vm.emojiShow) ? _c('div', {
    staticClass: "emojiBlock"
  }, [_c('swiper', {
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.swiperSlides), function(slide, index) {
    return _c('swiper-slide', {
      key: index,
      staticStyle: {
        "padding": "15px 0 30px"
      }
    }, _vm._l((slide), function(item) {
      return _c('img', {
        attrs: {
          "src": item.File,
          "alt": "",
          "id": item.ID,
          "tag": item.Tag
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.senEmoji(item.Tag)
          }
        }
      })
    }), 0)
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 2)], 1) : _vm._e()]), _vm._v(" "), (_vm.imgPreviewBlock) ? _c('div', {
    staticClass: "enlargePicture",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.imgPreviewBlock = false
      }
    }
  }, [_c('swiper', {
    ref: "swiper",
    attrs: {
      "options": _vm.swiperOptionImg
    }
  }, [_vm._l((_vm.imgArr), function(img, index) {
    return _c('swiper-slide', {
      key: index,
      staticStyle: {
        "padding": "15px 0 30px"
      }
    }, [_c('div', {
      staticClass: "pinch-zoom",
      staticStyle: {
        "width": "100%",
        "height": "100%"
      }
    }, [(img) ? _c('img', {
      staticClass: "previewImg",
      attrs: {
        "src": img,
        "alt": ""
      }
    }) : _c('img', {
      staticClass: "previewImg",
      attrs: {
        "src": require("../../common/img/defaultPicture.png"),
        "alt": ""
      }
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.topShow) ? _c('div', {
    staticClass: "toTop"
  }, [(_vm.praiseStatus) ? _c('span', {
    staticClass: "collectNo",
    style: ({
      backgroundImage: _vm.collect1_url,
      backgroundSize: 'contain'
    }),
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.collect(_vm.infoDetails.newsId)
      }
    }
  }, [(_vm.infoDetails.praisecount > 999) ? _c('span', [_vm._v("999+")]) : (_vm.infoDetails.praisecount > 0) ? _c('span', [_vm._v(_vm._s(_vm.infoDetails.praisecount))]) : _vm._e()]) : _c('span', {
    staticClass: "collectNo",
    style: ({
      backgroundImage: _vm.collect1_url,
      backgroundSize: 'contain'
    }),
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.collect(_vm.infoDetails.newsId)
      }
    }
  }, [(_vm.infoDetails.praisecount > 999) ? _c('span', [_vm._v("999+")]) : (_vm.infoDetails.praisecount > 0) ? _c('span', [_vm._v(_vm._s(_vm.infoDetails.praisecount))]) : _vm._e()])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "listName"
  }, [_c('span', [_vm._v("热门资讯")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-886d1b70!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/atlas/App.vue
// module id = 422
// module chunks = 4